import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {BroadcasterService} from "../broadcaster.service";
import {firstValueFrom, Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {UserModel} from "../../shared/models/user.model";

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor(private http: HttpClient, private broadcaster: BroadcasterService) { }
    public authUser(): Observable<UserModel> {
        return new Observable<UserModel>(observer => {
            this.http.post<any>(environment.apiUrl + 'adie/authUser', {sid: localStorage.getItem('token')})
                .subscribe((res: any) => {
                    this.broadcaster.broadcast('auth', res);
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
  async login(email: any, password: any): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'adie/login', {email, password}));
      localStorage.setItem('token', res[1].session_id);
      this.broadcaster.broadcast('login', res[0]);
      // localStorage.setItem('token', res.access_token);
      return res;
    } catch(e) {
      throw e;
    }
  }
  //   public login(email: any, password: any): Observable<UserModel> {
  //     return new Observable<any>(observer => {
  //         this.http.post<any>(environment.apiUrl + 'adie/login', {email, password}).subscribe({
  //             next: (res: any) => {
  //                 localStorage.setItem('token', res[1].session_id);
  //                 this.broadcaster.broadcast('login', res[0]);
  //                 observer.next(res);
  //                 },
  //             error: (err: any) => {
  //                 observer.error(err);
  //             }
  //         });
  //     });
  // }
    public logout(): Observable<any> {
        return new Observable<any>(observer => {
            this.http.post<any>(environment.apiUrl + 'adie/logout', {sid: localStorage.getItem('token')}).subscribe({
                next: (res: any) => {
                    observer.next(res);
                    localStorage.removeItem('token');
                    // localStorage.removeItem('formTypeFilter');
                    // localStorage.removeItem('orgTypeFilter');
                    // localStorage.removeItem('textractFilter');
                    this.broadcaster.broadcast('logout');
                },
                error: (err: any) => {
                    observer.error(err);
                }
            });
        });
    }
  public runLaz(): Observable<any> {
      return new Observable<any>(observer => {
          this.http.post<any>(environment.apiUrl + 'de/runLazTest', {}).subscribe({
              next: (res: any) => {
                  observer.next(res);
                  },
              error: (err: any) => {
                  observer.error(err);
              }
          });
      });
  }
}
